import { useQueries } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import { AreaPolygons } from './useIndexPolygons';

const useIndexPolygonList = (ids: string[]) => {
  return useQueries({
    queries: ids.map((id) => ({
      queryKey: ['polygon', id],
      queryFn: async (): Promise<AreaPolygons['area_polygons'] | null> => {
        const URL = `${import.meta.env.VITE_API_INDEX_POLYGON_URL}?id=${id}`;
        const { data } = await axiosClient.get<AreaPolygons>(URL);

        return data?.area_polygons ?? null;
      },
      staleTime: Infinity,
    })),
  });
};

export default useIndexPolygonList;
